<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6,10C6,10,10,10,10,10C10.55,10,11,9.55,11,9C11,8.45,10.55,8,10,8C10,8,6,8,6,8C5.45,8,5,8.45,5,9C5,9.55,5.45,10,6,10C6,10,6,10,6,10ZM15.93,5.63C15.93,5.63,15.93,5.63,15.93,5.63C15.93,5.63,15.93,5.61,15.93,5.61C15.93,5.61,15.93,5.61,15.93,5.61C15.93,5.61,13.94,0.63,13.94,0.63C13.94,0.63,13.94,0.63,13.94,0.63C13.78,0.26,13.42,0,13,0C13,0,3,0,3,0C2.58,0,2.22,0.26,2.07,0.63C2.07,0.63,2.07,0.63,2.07,0.63C2.07,0.63,0.08,5.61,0.08,5.61C0.08,5.61,0.08,5.61,0.08,5.61C0.08,5.61,0.07,5.63,0.07,5.63C0.07,5.63,0.07,5.63,0.07,5.63C0.03,5.74,0,5.87,0,6C0,6,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,6,16,6C16,5.87,15.97,5.74,15.93,5.63C15.93,5.63,15.93,5.63,15.93,5.63ZM9,2C9,2,12.32,2,12.32,2C12.32,2,13.52,5,13.52,5C13.52,5,9,5,9,5C9,5,9,2,9,2C9,2,9,2,9,2ZM3.68,2C3.68,2,7,2,7,2C7,2,7,5,7,5C7,5,2.48,5,2.48,5C2.48,5,3.68,2,3.68,2C3.68,2,3.68,2,3.68,2ZM14,14C14,14,2,14,2,14C2,14,2,7,2,7C2,7,14,7,14,7C14,7,14,14,14,14C14,14,14,14,14,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Box',
} as DefineComponent
</script>
